module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/terms/terms-page/terms-page.component.css
// module id = ./src/app/components/terms/terms-page/terms-page.component.css
// module chunks = main